var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"iframe-container"},[_c('iframe',{attrs:{"src":"https://www.facebook.com/100000503408593/videos/1172884443203042/","width":"100%","height":"800","frameborder":"0","allowfullscreen":""}}),_c('p',[_vm._v("Powered by "),_c('a',{attrs:{"href":"https://restream.io"}},[_vm._v("Restream.io")])])])])
}]

export { render, staticRenderFns }